module.exports = __webpack_public_path__ + "src/assets/img/german-selector-trajectory.1e5afad0.png";